import { Stack, Typography } from '@mui/material';
import { StoreResult } from 'api/client-domain/client-domain.types';
import { formatPhoneNumber } from 'react-phone-number-input';
import { formatAddress } from 'util/location';

type RelatedLocationSubheaderProps = {
  relatedLocation: Partial<StoreResult>;
};

const RelatedLocationSubheader = ({
  relatedLocation,
}: RelatedLocationSubheaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography gutterBottom color="text.secondary">
        {formatAddress(relatedLocation?.address)}
      </Typography>
      <Typography gutterBottom color="text.secondary" ml={2}>
        {formatPhoneNumber(
          relatedLocation?.phoneNumber?.startsWith('+')
            ? relatedLocation?.phoneNumber
            : `+1${relatedLocation?.phoneNumber}`,
        )}
      </Typography>
    </Stack>
  );
};

export default RelatedLocationSubheader;
